import React, { forwardRef } from "react";
import { Link, useLocation } from "react-router-dom";

import SimpleBar from "simplebar-react";

import FeatherIcon from "feather-icons-react";
import paths from "../../route/paths";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import {
  filterSelector,
  flutterMessageSelector,
  lastLocationSelector,
  webViewSelector,
} from "../../actions/LayoutMode.actions";
import { permissionsSelector } from "../../actions/Authentication.actions";
import { Permissions } from "../../models/Types";
import { postMessageCall } from "../../internals/asd";

export interface SidebarProps {
  setSidebarIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Sidebar = forwardRef(({ setSidebarIsOpen }: SidebarProps, ref: any) => {
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  const permissionList = useRecoilValue(permissionsSelector);
  const isWebView = useRecoilValue(webViewSelector);
  const resetFilters = useResetRecoilState(filterSelector);
  const resetMessages = useResetRecoilState(flutterMessageSelector);

  const { pathname } = useLocation();

  const setIsLoggedIn = useSetRecoilState(lastLocationSelector);

  const sidebarClick = (url: string): void => {
    resetFilters();
    resetMessages();

    setIsLoggedIn({ location: url });

    isMobile && setSidebarIsOpen(false);
  };

  const viewAppointmentPermission = permissionList[Permissions.ViewAppointment];
  const viewCustomerListPermission = permissionList[Permissions.ViewCustomer];
  const addCustomerPermission = permissionList[Permissions.AddCustomer];
  const viewTodoPermission = permissionList[Permissions.ViewTodo];
  const viewStockPermission = permissionList[Permissions.ViewDevice];
  const viewStaffPermission = permissionList[Permissions.ViewUser];
  const viewSupplierPermission = permissionList[Permissions.ViewSupplier];
  const viewCostPermission = permissionList[Permissions.ViewCategory];
  const viewTransactionPermission =
    permissionList[Permissions.ViewDevicebuysell];

  return (
    <React.Fragment>
      <div ref={ref} className="vertical-menu">
        <div data-simplebar className="h-100">
          <React.Fragment>
            <SimpleBar style={{ maxHeight: "100%" }}>
              <div id="sidebar-menu">
                <ul className="metismenu list-unstyled" id="side-menu">
                  {viewCustomerListPermission && (
                    <li
                      className={
                        pathname === paths.DASHBOARD ? "mm-active" : ""
                      }
                    >
                      <Link
                        onClick={() => sidebarClick(paths.DASHBOARD)}
                        to={paths.DASHBOARD}
                      >
                        <FeatherIcon icon="home" /> <span>{"Ana sayfa"}</span>
                      </Link>
                    </li>
                  )}

                  {viewCustomerListPermission && (
                    <li
                      className={
                        pathname === paths.CUSTOMER.CUSTORMER_LIST
                          ? "mm-active"
                          : ""
                      }
                    >
                      <Link
                        onClick={() =>
                          sidebarClick(paths.CUSTOMER.CUSTORMER_LIST)
                        }
                        to={paths.CUSTOMER.CUSTORMER_LIST}
                      >
                        <FeatherIcon icon="users" />{" "}
                        <span>{"Tüm Müşteriler"}</span>
                      </Link>
                    </li>
                  )}

                  {viewCustomerListPermission && (
                    <li
                      className={
                        pathname === paths.MAINTENANCE ? "mm-active" : ""
                      }
                    >
                      <Link
                        onClick={() => sidebarClick(paths.MAINTENANCE)}
                        to={paths.MAINTENANCE}
                      >
                        <FeatherIcon icon="sliders" />{" "}
                        <span>{"Bakıma Kalan Gün"}</span>
                      </Link>
                    </li>
                  )}

                  {viewCustomerListPermission && (
                    <li
                      className={
                        pathname === paths.RECEIVABLE ? "mm-active" : ""
                      }
                    >
                      <Link
                        onClick={() => sidebarClick(paths.RECEIVABLE)}
                        to={paths.RECEIVABLE}
                      >
                        <FeatherIcon icon="dollar-sign" />{" "}
                        <span>{"Alınacak Ücretler"}</span>
                      </Link>
                    </li>
                  )}

                  {addCustomerPermission && (
                    <li
                      className={
                        pathname === paths.CUSTOMER.CUSTORMER_ADD
                          ? "mm-active"
                          : ""
                      }
                    >
                      <Link
                        onClick={() =>
                          sidebarClick(paths.CUSTOMER.CUSTORMER_ADD)
                        }
                        to={paths.CUSTOMER.CUSTORMER_ADD}
                      >
                        <FeatherIcon icon="user-plus" />{" "}
                        <span>{"Müşteri Ekle"}</span>
                      </Link>
                    </li>
                  )}

                  {viewTodoPermission && (
                    <li className={pathname === paths.TODO ? "mm-active" : ""}>
                      <Link
                        onClick={() => sidebarClick(paths.TODO)}
                        to={paths.TODO}
                      >
                        <FeatherIcon icon="layers" />{" "}
                        <span>{"Yapılacak İş Listesi"}</span>
                      </Link>
                    </li>
                  )}

                  <li className={pathname === paths.CONSOLE ? "mm-active" : ""}>
                    <Link
                      onClick={() => sidebarClick(paths.CONSOLE)}
                      to={paths.CONSOLE}
                    >
                      <FeatherIcon icon="clipboard" />{" "}
                      <span>{"Son Düzenlemeler"}</span>
                    </Link>
                  </li>

                  {viewAppointmentPermission && (
                    <li
                      className={
                        pathname === paths.APPOINTMENT ? "mm-active" : ""
                      }
                    >
                      <Link
                        onClick={() => sidebarClick(paths.APPOINTMENT)}
                        to={paths.APPOINTMENT}
                      >
                        <FeatherIcon icon="calendar" />{" "}
                        <span>{"Randevular"}</span>
                      </Link>
                    </li>
                  )}

                  {viewStockPermission && (
                    <li className={pathname === paths.STOCK ? "mm-active" : ""}>
                      <Link
                        onClick={() => sidebarClick(paths.STOCK)}
                        to={paths.STOCK}
                      >
                        <FeatherIcon icon="package" /> <span>{"Stok"}</span>
                      </Link>
                    </li>
                  )}

                  <li
                    className={pathname === paths.STATISTICS ? "mm-active" : ""}
                  >
                    <Link
                      onClick={() => sidebarClick(paths.STATISTICS)}
                      to={paths.STATISTICS}
                    >
                      <FeatherIcon icon="package" /> <span>{"İstatistik"}</span>
                    </Link>
                  </li>

                  {viewStaffPermission && (
                    <li className={pathname === paths.STAFF ? "mm-active" : ""}>
                      <Link
                        onClick={() => sidebarClick(paths.STAFF)}
                        to={paths.STAFF}
                      >
                        <FeatherIcon icon="users" />{" "}
                        <span>{"Personeller"}</span>
                      </Link>
                    </li>
                  )}

                  {viewTransactionPermission && (
                    <li
                      className={pathname === paths.BUYSELL ? "mm-active" : ""}
                    >
                      <Link
                        onClick={() => sidebarClick(paths.BUYSELL)}
                        to={paths.BUYSELL}
                      >
                        <FeatherIcon icon="shopping-bag" />
                        <span>{"Alış/Satış"}</span>
                      </Link>
                    </li>
                  )}

                  {viewSupplierPermission && (
                    <li
                      className={pathname === paths.SUPPLIER ? "mm-active" : ""}
                    >
                      <Link
                        onClick={() => sidebarClick(paths.SUPPLIER)}
                        to={paths.SUPPLIER}
                      >
                        <FeatherIcon icon="shopping-bag" />{" "}
                        <span>{"Tedarikçi"}</span>
                      </Link>
                    </li>
                  )}

                  {viewCostPermission && (
                    <li
                      className={pathname === paths.EXPENSE ? "mm-active" : ""}
                    >
                      <Link
                        onClick={() => sidebarClick(paths.EXPENSE)}
                        to={paths.EXPENSE}
                      >
                        <FeatherIcon icon="briefcase" /> <span>{"Gider"}</span>
                      </Link>
                    </li>
                  )}

                  <li className={pathname === paths.COMPANY ? "mm-active" : ""}>
                    <Link
                      onClick={() => sidebarClick(paths.COMPANY)}
                      to={paths.COMPANY}
                    >
                      <FeatherIcon icon="briefcase" /> <span>{"Firma"}</span>
                    </Link>
                  </li>

                  {/* <li className={pathname === paths.PROFILE ? "mm-active" : ""}>
                    <Link onClick={() => sidebarClick(paths.PROFILE)} to={paths.PROFILE}>
                      <FeatherIcon icon="user" /> <span>{"Profil"}</span>
                    </Link>
                  </li> */}

                  {/* 
                  <li>
                    <Link onClick={() => sidebarClick()} to="/maps">
                      <FeatherIcon icon="chrome" /> <span>{'Web Sitem'}</span>
                    </Link>
                  </li> */}
                </ul>
                {isMobile && (
                  <div className="card sidebar-alert border-0 text-center mx-4 mb-0 mt-5">
                    <div className="card-body">
                      {/* <img src={giftBox} alt="" /> */}
                      <div className="mt-4">
                        <h5 className="alertcard-title font-size-16">
                          Müşteri Hizmetleri
                        </h5>
                        <p className="font-size-13">
                          Her hangi bir sorun karşısında sürekli olarak
                          yanınızdayız.
                        </p>
                        <Link
                          onClick={() => {
                            postMessageCall(`05397350756`);
                          }}
                          to={"#"}
                          className="btn btn-primary mt-2"
                        >
                          Hemen Ulaşın <FeatherIcon icon="phone" />
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </SimpleBar>
          </React.Fragment>
        </div>
      </div>
    </React.Fragment>
  );
});

export default Sidebar;
